/**
 * Petmall — contain the stylesheet the Recharge "Научи повече" modal injects.
 *
 * Opening the modal appends a <style> to the page (not to the widget's shadow root)
 * whose first rules are unscoped:
 *
 *     .rc-purchase-option__sub-container { position: relative!important; }
 *     img { position: absolute!important; width: 25%!important; right: 20px!important;
 *           top: 0!important; aspect-ratio: 1!important; }
 *
 * That bare `img` selector is plainly meant for the icon inside the purchase option, but
 * it matches every image in the document — product gallery, cards, logo — and tears the
 * page apart for as long as the modal has been opened once. The rule is `!important` and
 * as unspecific as a selector gets, so it cannot be beaten from our own stylesheet; the
 * reliable fix is to scope the selector as the stylesheet arrives.
 *
 * Only that one top-level `img` rule is rewritten. Every other rule in the sheet is
 * already prefixed with `rc-learn-more-modal`, and those are left untouched, so the modal
 * still renders exactly as Recharge intends.
 */
(function () {
  const DONE = 'data-petmall-scoped';
  const SCOPE = '.rc-purchase-option__sub-container ';
  // A bare `img {` at the top level: start of sheet, or straight after a closing brace.
  const BARE_IMG = /(^|\})(\s*)img(\s*\{)/g;

  function scope(style) {
    if (!style || style.tagName !== 'STYLE' || style.hasAttribute(DONE)) return;
    const css = style.textContent || '';
    if (!css.includes('rc-learn-more-modal')) return;
    BARE_IMG.lastIndex = 0;
    if (!BARE_IMG.test(css)) return;
    BARE_IMG.lastIndex = 0;
    style.textContent = css.replace(BARE_IMG, '$1$2' + SCOPE + 'img$3');
    style.setAttribute(DONE, '');
  }

  function scan(node) {
    if (node.nodeType !== 1) return;
    if (node.tagName === 'STYLE') scope(node);
    else node.querySelectorAll && node.querySelectorAll('style').forEach(scope);
  }

  new MutationObserver((records) => {
    for (const record of records) {
      record.addedNodes.forEach(scan);
      // Recharge fills the element after inserting it, so re-check on text changes too.
      if (record.type === 'characterData') scope(record.target.parentElement);
    }
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
  });

  document.querySelectorAll('style').forEach(scope);
})();
